import _pt from "prop-types";
import * as React from 'react';
import DSIconCPRA from '@lmig/design-system-icons-react/_cjs/system/CPRA';
import IconWrapper from '../IconWrapper';
var IconCPRA = function IconCPRA(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement(DSIconCPRA, null));
};
IconCPRA.propTypes = {
  /** Specify the pixel size of the SVG's containing square. */size: _pt.oneOf(['24', '32'])
};
export default IconCPRA;